import { createGrid, themeQuartz } from 'ag-grid-community'
import { hideElement, showElement } from '../../../../helpers/generic-js/dom.js'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'
import { loadData } from './load-data.js'

const context = {
  data: {}
}

export let gridApi

/**
 *
 */
export async function updateView (browserAppEntity) {
  console.log('updateView')
  console.log('browserAppEntity', browserAppEntity)
  showElement('statementLoadingMessage')
  hideElement('statementContainer')

  // Params in use
  context.accountingOrganisationId = browserAppEntity.data.accountingOrganisationId

  // Load data
  await loadData(context)
  console.log('context', context)

  // Include Top Pinned row with total of amounts

  const containerId = 'grid'
  const gridContainerElement = document.getElementById(containerId)

  const indexedChartOfAccounts = context.accountData?.chartOfAccounts?.indexed
  const gridRowsData = makeRows(context.data, indexedChartOfAccounts)

  if (gridApi && gridContainerElement.innerHTML) {
    gridApi.setGridOption('rowData', gridRowsData)
  } else {
    const gridOptions = {
      rowData: gridRowsData,
      columnDefs: makeColumnDefs(context),
      defaultColDef: {
        filter: true,
        floatingFilter: true,
        onCellClicked: function (cellParams) {
          console.log(cellParams)
        }
      },
      autoSizeStrategy: {
        type: 'fitCellContents'
      },
      context,
      theme: themeQuartz
    }
    gridApi = createGrid(gridContainerElement, gridOptions)
  }

  console.log('gridApi', gridApi)

  hideElement('statementLoadingMessage')
  showElement('statementContainer')
}
